<template>
  <div class="popup-code" @click.stop="() => {}">
    <div class="code-bg">
      <h4>{{ area.codeTitle }}</h4>
      <h4>{{ area.codeSubTitle }}</h4>
      <img :src="area.codeImage" />
    </div>
  </div>
</template>

<script>
export default {
  
}
</script>

<style lang="scss" scoped>
.popup-code {
  position: relative;
  margin-top: .4rem;
  .code-bg {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0 .5rem;
    padding: .5rem 0 .3rem;
    background: #FFF;
    border-radius: 8px;
    h4 {
      font-size: .28rem;
      line-height: .46rem;
      text-align: center;
    }
    img {
      margin-top: .2rem;
      display: block;
      width: 4rem;
      height: 4rem;
    }
  }
}
</style>